export default function() {
  return {
    entityProps: [],
    entityModels: [],
    computedLayers: [],
    layerRegistry: [],
    activeLayers: [],
    staticLayers: [],
    activeStaticLayers: [],
  };
}
